import React,{useMemo,useState,useEffect} from 'react'
import { Box, CircularProgress,Grid,Typography,Tooltip, Button } from '@mui/material';
import DyDataGrid from '../../../../components/GlobalComponents/DyDataGrid3/DyDataGrid';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer ,Legend,Tooltip as Tp} from 'recharts';
import { useSelector } from 'react-redux';
import { useGetKeyResultMeetingHistory ,useGetKeyResultMeetingHistory1} from '../../Hooks';
import AttachmentIcon from '@mui/icons-material/Attachment';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import { CreateAttachment } from '../Forms/CreateAttachment/CreateAttachment';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const KrHistoryModalContent = ({krId,priodId,meetingId,krDetail,objective,setShowModal}:any) => {
  const meetSelectedDate = useSelector((state: any) => state.meetings.meetSelectedDate);
  const priodName = useSelector((state: any) => state.meetings.periodName);
  const [dataHistory, setdataHistory] = useState<any>([]);
  // const [dataHistory3, setdataHistory1] = useState<any>([]);
  const [krIdd, setKrId] = useState(krId);
  const [meetingIdd, setMeetingId] = useState(meetingId);
  const [showAttachment, setShowAttachment] = useState(false);
  const {
    data: dataHistory1,
    isLoading: loadingFlag,
  } = useGetKeyResultMeetingHistory(krId, priodId, meetingId);

  const {
    data: dataHistory11,
    isLoading: loadingFlag1,
  } = useGetKeyResultMeetingHistory1(krId, priodId, meetingId);

  useEffect(() => {
    if (dataHistory1) {
      setdataHistory(dataHistory1);
    }
  }, dataHistory1);

  // useEffect(() => {
  //   if (dataHistory11) {
  //     setdataHistory1(dataHistory11);
  //   }
  // }, dataHistory11);

  const [daataa, setdaataa] = useState<any>([]);
  useEffect(() => {
   if (dataHistory11) {
     const validData = dataHistory11?.filter((item : any) => 
       item.reportScore !== null && item.reportScore !== undefined && !isNaN(item.reportScore) &&
       item.newValue !== null && item.newValue !== undefined && !isNaN(item.newValue)
   );
    setdaataa(validData);
   }
 }, dataHistory11);

 const [imgSrc, setImgSrc] = useState<string | null>(null);
 const [krMainInfo, setKrMainInfo] = useState<any>(null);
 const [showToastMessage, setShowToastMessage] = useState<any>(false);
 const [showImageSelector, setShowImageSelector] = useState<boolean>(false);
 const handleImageChange = (newImgSrc: string) => {
   setImgSrc(newImgSrc);
   localStorage.setItem('tenantImage', newImgSrc); // Save to localStorage
   setShowImageSelector(false);
 };
 const handleToastMessage = (message: string) => {
   setShowToastMessage(true);
   setTimeout(() => setShowToastMessage(false), 3000); // Hide toast after 3 seconds
 };

 const handleImageSelectorClose = () => {
   setShowImageSelector(false);
 };

 const [columnWidths, setColumnWidths] = useState({
  comment: 100,
  name: 400,
  responsibleName: 125,
  responsibleName2: 125,
  keyResultCount:100,
  objectivesStateName:150,
  evaluationPercentage:90,
  oldScore:75,
  score:75,
  difference:100,
  difference2:100,
  currentState:110,
  combinedScore:120,
  evaluationSummary:400,
  combinedField:50,
  oldValue:115,
  oldScore2:75,
  combinedValue:120,
});

    const KRHColumns: any = useMemo(()=>
    [
      {
        field: "rowid",
        headerName: "ردیف",
        width: 35,
        sortable: false,
        align:'center',
        headerAlign:'center',
        renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
      },
      {
        field: "combinedField",
        headerName: "",
        align: "center",
        headerAlign: "center",
        sortable: false,
        // minWidth: 160,
        width: columnWidths.combinedField,
        // renderHeader: (params:any) => (
        //   <div style={headerCellStyle}>
        //     {params.colDef.headerName}
        //     <div
        //       style={resizeHandleStyle}
        //       onMouseDown={(e) => handleMouseDown(e, 'combinedField')}
        //     />
        //   </div>
        // ),
        renderCell: ({ row }: any) => {
          const { problems, description, commentCount, keyResultId,id, name, nextState, attachment } = row; 
          // const handleDoubleClick = () => {
          //   setKrId(id);
          //   setShowAddEvalModal(true);
          // };
      
          return (
            <Box display="flex" justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
              <Box sx={{ width: "40px", textAlign: "center" }}>
                {attachment && (
                  <Tooltip title="ضمیمه موجود است">
                    <Button
                    sx={{ fontSize: "10px" }}
                    variant="text"
                    onClick={() => {
                      setShowAttachment((prev: any) => !prev);
                      setMeetingId(id);
                      setKrMainInfo(row);
                    }}
                    startIcon={<AttachmentIcon />}
                  >
                  </Button>
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ width: "40px", textAlign: "center", cursor: "pointer" }} >
                {problems && (
                  <Tooltip title={`موانع: ${problems}`} sx={{ fontSize: "1.5rem !important" }}>
                    <MailOutlineIcon sx={{ fontSize: "18px" }} />
                  </Tooltip>
                )}
              </Box>
      

              <Box sx={{ width: "40px", textAlign: "center", cursor: "pointer" }} >
                {description && (
                  <Tooltip title={`توضیحات: ${description}`} sx={{ fontSize: "1.5rem !important" }}>
                    <MailOutlineIcon sx={{ fontSize: "18px" }} />
                  </Tooltip>
                )}
              </Box>
      
              {/* <Box sx={{ width: "80px", textAlign: "center" }}>
                {nextState && (
                  <Tooltip title={nextState}>
                    {(() => {
                      switch (nextState) {
                        case "انتظار داریم به نتیجه درست برسیم":
                          return <img src={smil} width={"25px"} style={{ verticalAlign: 'middle' }} />;
                        case "با ریسک عدم دستیابی مواجه هستیم اما تمام تلاش خود را خواهیم کرد":
                          return <img src={meh} width={"25px"} style={{ verticalAlign: 'middle' }} />;
                        case "اعتقادی نداریم به نتیجه برسیم مگر اینکه رویکرد جدیدی اتخاذ کنیم":
                          return <img src={sad} width={"25px"} style={{ verticalAlign: 'middle' }} />;
                        default:
                          return <span />;
                      }
                    })()}
                  </Tooltip>
                )}
              </Box> */}
      
              {/* <Box sx={{ width: "40px", textAlign: "center" }}>
                <CommentModal id={id} name={name} meetingId={meetingId} commentCount={commentCount} />
              </Box> */}
            </Box>
          );
        },
      },
      { field: 'meetingDate',
           headerName: 'تاریخ جلسه',
           sortable:false,
           headerAlign:'center',
           align:'center',
            width: 100,
            }
            ,
          { field: 'newValue',
          headerName: 'مقدار اعلام شده',
          align:'center',
          sortable:false,
          headerAlign:'center',
           width: 170,
           renderCell:({value}:any)=>{
            return <Box>
             {
              value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
              {value}
            </Tooltip>:
            <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
             }
            </Box>
          }
           }
           ,
           { field: 'currentState',
         headerName: 'وضعیت ',
         align:'center',
         sortable:false,
         headerAlign:'center',
          minWidth: 120 ,
          renderCell:({value}:any)=>{
            return<Box m={3} 
            
            borderRadius={2} 
            width={'100%'} 
            display={'flex'} 
            justifyContent={'center'} 
            alignItems={'center'} 
            height={'75%'}   
            bgcolor={value==='در مسیر مناسب'?'#D5F7D4':value==='نیازمند توجه'?'#FFEBEF':'#F0F1F2'}  >
   
              <Typography fontSize={'12px'} px={8} color={value==='نیازمند توجه'?'#F95700':value==='خارج از مسیر مناسب'?'#CC0030':'black'} >
              {value}
              </Typography>
            </Box>
                }
        
        }
            ,
        { field: 'meetingNumber',
         align:'center',
         headerName: 'شماره جلسه',
         headerAlign:'center',
         sortable:false,
         wrap:'wrap',
          minWidth: 130,
          fontsize:'12px !important',
    }
    ,
    {
      field: 'problems',
      headerName: 'موانع',
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      minWidth: 140,
      renderCell:({value}:any)=>{
        return <Box>
        
         {
          value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
          {value}
        </Tooltip>:
        <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
         }
        </Box>
      }
    },
    { field: 'score',
    headerName: 'امتیاز',
    align:'center',
    sortable:false,
    headerAlign:'center',
    width: 120 ,
    renderCell:(par:any)=>{
     let score:string=par?.row?.score;
     if ( typeof score==='string' &&  score.includes('%')) {
       let pureNum=score.slice(0,score.length-1);
       let intVal=+pureNum;
       let color='';
      let fColor=''
      switch (true) {
       case intVal>=70:
         color='#D5F7D4';
         fColor='#125610'
         break;
         case intVal<70 &&  intVal>30:
         color='#FFF8D0';
         fColor='#6B6440'
         break
       default:
         color='#FFEEE5'
         fColor='#993600'
         break;
      }
       return <Box m={3} 
       borderRadius={2} 
       width={'100%'} 
       display={'flex'} 
       justifyContent={'center'} 
       alignItems={'center'} 
       height={'65%'}   
       bgcolor={color}
       my={1}
        >
         <Typography px={8} fontSize={'0.8rem'} color={fColor} fontWeight={400} >
         {intVal}
         </Typography>
       </Box> 
     }
     else{
       return<Box>
         <Typography>{score}</Typography>
       </Box>
     }    
    }
   }
   ,  
          { field: 'startValue',
          headerName: 'مقدار شروع',
          sortable:false,
          headerAlign:'center',
          align:'center',
           width: 110 ,
           renderCell:({value}:any)=>{
            return <Box>
             {
              value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
              {value}
            </Tooltip>:
            <Typography  sx={{fontSize:'12px'}} >
              {value}
              </Typography>
             }
            </Box>
          }
          },
          {
            field: 'revenue',
            headerName: 'عملکرد',
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            minWidth: 130,
            renderCell: ({ value }: any) => {
            if (value) {
              return <Box>
              {
                value.length > 40 ? <Tooltip sx={{ fontSize: '1.5rem !important' }} title={value}>
                  {value}
                </Tooltip> :
                  <Typography sx={{ fontSize: '12px' }} >{value}</Typography>
              }
            </Box>
            }
            }
          },
          {
            field: 'description',
            headerName: 'توضیحات',
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            minWidth: 300,
            renderCell: ({ value }: any) => {
            if (value) {
              return <Box>
              {
                value.length > 40 ? <Tooltip sx={{ fontSize: '1.5rem !important' }} title={value}>
                  {value}
                </Tooltip> :
                  <Typography sx={{ fontSize: '12px' }} >{value}</Typography>
              }
            </Box>
            }
            }
          },
      ],[]);

      const[krDetailSps,setKrDetailSps]=useState<any>(null);

      useEffect(() => {
        if (krDetail && objective ) {
          let{name}=krDetail;
          let{name:objectiveName}=objective;
          let details:any={
            krName:name,
            objectiveName:objectiveName,
            priodName:priodName
          }
          setKrDetailSps(details)
        }
      }, [krDetail,objective])
      

    if(loadingFlag){
     return <Box width={'100%'} py={4}  textAlign={'center'}  >
   <CircularProgress  color='info'  />
     </Box>
    }
    let KRHistoryinitialState={
      columns: {
        columnVisibilityModel: {
          meetingNumber:false,
          startValue:false,
        },
      },
    }

    const CustomTooltip = ({ active, payload, label } : any) => {
      if (active && payload && payload.length) {
        return (
          <div className="custom-tooltip" style={{ backgroundColor: '#00387C', color : '#fff' ,padding: '10px', border: '4px solid #ccc' }}>
        <p className="label">{`تاریخ: ${label}`}</p>
        <p>{`امتیاز: ${payload[0] !== null && payload[0] !== undefined ? payload[0].value : '-'}`}</p>
        <p>{`مقدار جدید: ${payload[1] !== null && payload[1] !== undefined ? payload[1].value : '-'}`}</p>
      </div>
        );
      }
      return null;
    };

  return (
    <Grid container  >
      <Grid item xs={12}  >
      <Grid container px={2}  >
         <Grid item xs={12} md={12}  >
        <Box display={'flex'} justifyContent={'space-between'}  >
        <Box>
          <Typography fontWeight={700}  >
          نام هدف  :
            {
            krDetailSps?.objectiveName
            }
          </Typography>
         </Box>
         <Box>
         <Typography variant='body1'  >
          تاریخ :
            {
            meetSelectedDate
            }
          </Typography>
         </Box>
        </Box>
         </Grid>
         <Grid item xs={12} md={6}>
         <Box mt={2}  >
          <Typography variant='body2'>
          شرح نتیجه کلیدی :
            {
            krDetailSps?.krName
            }
          </Typography>
         </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box mt={2} textAlign={'right'} >
          <Typography textAlign={'right'} variant='body2'>
          دوره زمانی :
            {
            krDetailSps?.priodName
            }
          </Typography>
         </Box>
          
          </Grid>
      </Grid>
      </Grid>

      <Grid item xs={12}   >
      <Box p={1}  >
      <DyDataGrid  
        data={dataHistory} 
        columns={KRHColumns||[]} 
        hideFooter={false}
        selectionModel={''}
        initialOnRowClick={()=>{}}
        additionalToolbar={false}
        setSelectionModel={()=>{}}
        initState={KRHistoryinitialState}
        setSpecialId={setKrId}
        setShowAttachment={setShowAttachment}
        />
      </Box>
      </Grid>
      <Grid container item  xs={16} justifyContent="center" width={'400px'} height={'300px'}
      >
        {
          dataHistory !== null && dataHistory !== undefined
          && dataHistory.length !== 0 ?
         <Grid container item  xs={16} justifyContent="center" width={'400px'} height={'300px'}>
          <Typography px={1} variant='button' fontWeight={900} color={'black'} > سابقه ارزیابی های اخیر</Typography>
          <ResponsiveContainer width="100%" height={400}>
          <LineChart
            data={daataa}
            margin={{
              top: 20,    // فضای بالا
              right: 40,  // فضای سمت راست
              left: 40,   // فضای سمت چپ
              bottom: 30  // فضای پایین
            }}
          >
        <CartesianGrid strokeDasharray="3 3" /> {/* شبکه در پس‌زمینه */}
        <XAxis dataKey="meetingDate" />
        <YAxis
          yAxisId="left"
          label={{ value: 'امتیاز', angle: -90, position: 'insideLeft', offset: 10 }}
          tick={{ fontSize: 12, dx: -10 }} // فاصله افقی تیک‌ها
          tickSize={10} // اندازه تیک‌ها
          tickFormatter={(value) => value.toFixed(0)}
          interval={0} // فاصله بین تیک‌ها
          domain={[0, 100]} // محدوده محور از 0 تا حداکثر مقدار داده‌ها
        />
        <YAxis
          yAxisId="right"
          label={{ value: 'مقدار جدید', angle: 90, position: 'insideRight', offset: 10 }}
          orientation="right"
          tick={{ fontSize: 12, dx: 10 }} // فاصله افقی تیک‌ها
          tickSize={10} // اندازه تیک‌ها
          tickFormatter={(value) => value.toFixed(0)}
          interval={0} // فاصله بین تیک‌ها
          domain={dataHistory[0]?.max === 0 ? []: [0, dataHistory[0]?.max]} // محدوده محور از 0 تا حداکثر مقدار داده‌ها
        />
        {/* <Tooltip /> ابزار راهنما برای نمایش جزئیات */}
        <Legend 
          wrapperStyle={{ padding: 20, textAlign: 'center' }} 
          formatter={(value: string) => {
            // تبدیل متن Legend به فارسی
            if (value === 'reportScore') return 'امتیاز';
            if (value === 'newValue') return 'مقدار جدید';
            return value;
          }}
        />
        <Tp 
             content={<CustomTooltip />}
            />
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="reportScore"
          stroke="#e28743"
          activeDot={{ r: 6 }}
          name="امتیاز" // نام خط برای فارسی کردن
        />
        <Line
          yAxisId="right"
          type="monotone"
          dataKey="newValue"
          stroke="#000"
          activeDot={{ r: 6 }}
          name="مقدار جدید" // نام خط برای فارسی کردن
        />
      </LineChart>
    </ResponsiveContainer>
          </Grid>
          :
          <Grid xs={12}>
          <Box  display={'flex'} alignItems={'center'} justifyContent={'space-between'} textAlign={'center'}>   
        </Box>
          </Grid>
        }
      </Grid>
      {showAttachment && (
          <ModalLyt
            //  loadingFlag={KRHLoading}
            title={"ضمیمه"}
            showModal={Boolean(showAttachment)}
            setShowModal={setShowAttachment}
          >
              <CreateAttachment
              cancelo={setShowModal}
              objectiveManiInfo={objective}
              krMainInfo={krMainInfo}
              meetingId={meetingIdd}
              setChangeImgData={handleImageChange}
              onClose={handleImageSelectorClose}
              // pointingSystem={pointingSystem}
              objectiveId={objective?.id}
              kresultId={krId}
              // afterAddKr={initialAfterAddKr}
              onsucces={setShowModal}
              setShowToastMessage={setShowToastMessage}
              setAddEvalAsyncData={()=>{}}
            />
            {/* <TenantIm
              // loadingFlag={KRHLoading}
              // data={KrHistoryData}
              krDetail={krRowData}
              objective={objectivee}
              meetingId={meetingId}
              priodId={priodId}
              krId={krId}
            /> */}
          </ModalLyt>
        )}

        {showToastMessage && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
    </Grid>
  )
}

export default KrHistoryModalContent


 